import React from 'react';
import { ContactPage } from '@/data';
import { useTranslation } from 'react-i18next';

const ContactOne = () => {
  const { title1, subtitle1, heading, form } = ContactPage;
  const { t } = useTranslation();
  return (
    <section className="contact_form_area">
      <div className="contact_form_width">
        <h1 className="contact_map_title text-center">{t(heading)}</h1>
        <div id="map">
          <iframe
            title="template google map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2498.567396080184!2d4.4261809764183075!3d51.227044471750894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3f7af3159eb3d%3A0x8dd5d0dd548ce679!2sStuivenbergplein%2011%2F1%2C%202060%20Antwerpen%2C%20Belgium!5e0!3m2!1sen!2snl!4v1741602175111!5m2!1sen!2snl"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className="contact_form_width contact-right">
        <div className="hero-title-with-shape">
          <h4 className="heading_with_border">{t(title1)}</h4>
          <h1>{t(subtitle1)}</h1>
        </div>
        <form action="#" method="post">
          <input
            className="half_width input_m_right"
            type="text"
            name="fname"
            placeholder={t(form.name)}
          />
          <input
            className="half_width"
            type="EMAIL"
            name="email"
            placeholder={t(form.email)}
          />
          <input type="tel" name="tell" placeholder={t(form.phone)} />
          <button className="btn-yellow" value="SUBMIT NOW">
            {t(form.submitBtn)}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactOne;
